.contentTypeIcon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
